import { AutoComplete, Input } from 'antd';
import React, { useCallback, useState } from 'react';
import { useFetchUsersQuery } from '@/graphql/generated/graphql';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './Header.module.pcss';

const HeaderSearch: React.FC = () => {
  const [searchValue, setSearchValue] = useState<string | undefined>();
  const navigate = useNavigate();

  const { data, loading } = useFetchUsersQuery({
    variables: {
      filters: {
        nameOrEmailOrIdentifier: searchValue,
      },
    },
    skip: !searchValue,
  });

  const usersOptions = data?.users.data.map((user) => ({
    key: user.newInfraId,
    label: user.name
      ? `${user.name}<${user.email}><${user.newInfraIdentifier}>`
      : user.email
      ? `${user.email}<${user.newInfraIdentifier}>`
      : user.newInfraIdentifier || user.newInfraId,
    value: user.name
      ? `${user.name}<${user.email}><${user.newInfraIdentifier}>`
      : user.email
      ? `${user.email}<${user.newInfraIdentifier}>`
      : user.newInfraIdentifier || user.newInfraId,
  }));

  const onSearchUsers = debounce(
    useCallback((value: string) => {
      setSearchValue(value);
    }, []),
    1500
  );

  const onSelectUser = (value: string, option: Record<'label' | 'value' | 'key', string>) => {
    navigate(`/v1/users/${option.key}`);
  };

  return (
    <AutoComplete
      filterOption={true}
      options={usersOptions}
      onSelect={onSelectUser}
      onChange={onSearchUsers}
      showSearch
      allowClear
      className={styles.headerSearch}
      popupMatchSelectWidth
    >
      <Input
        placeholder="Search user name/email/identifier"
        suffix={loading ? <LoadingOutlined /> : <SearchOutlined />}
      />
    </AutoComplete>
  );
};

export default HeaderSearch;
